import styles from './Hero.module.scss'
import condolence from "../../../images/icons/condolence.svg";
import flower from "../../../images/icons/flower.svg";
import candle from "../../../images/icons/candle.svg";
import {Person} from "@/types/person";
import {InteractionStats as InteractionStatsProps} from "@/types/interactionStats";
import Mensenlinq from "@/Atoms/Icons/Mensenlinq";
import Birth from "@/Atoms/Icons/Birth";
import Deceased from "@/Atoms/Icons/Deceased";
import InteractionStats from '@/Molecules/InteractionStats';

type HeroProps<T extends Record<string, unknown> = Record<string, unknown>> = T & {
  person: Person,
  stats?: InteractionStatsProps,
  claimed?: boolean,
};
export default function Hero(
  {
    person, stats, claimed, background
  }: HeroProps) {

  const {deceased, birth} = person

  const BirthAndDeceased = () =>
    (birth && deceased)
      ? <><i title={'Geboren op'}><Birth /></i>{birth} &bull;<i title={'Overleden op'}><Deceased/></i>{deceased}</>
      : (birth)
        ? <><i title={'Geboren op'}><Birth /></i>{birth}</>
        : (deceased)
          ? <><i title={'Overleden op'}><Deceased /></i>{deceased}</>
          : null
  const paperString = person.papers.map(paper => paper.title).join(', ')

  return <section className={`${styles.hero} ${claimed ? styles.claimed : ''}`}>
    <div className={`${styles.background} ${(claimed && person.background?.url) ? styles.backgroundClaimed : ''}`}>
      {(claimed && person.background?.url) ? <img src={person.background?.url} alt={''}/> : <Mensenlinq className={styles.shape}/>}
    </div>
    <div className={'px-5'}>
      <div className={`${styles.wrapper} container`}>

        {claimed && (
          <div className={styles.avatar}>
            {person.avatar?.url
              ? <img src={person.avatar.url} alt={person.name}/>
              : <Mensenlinq className={styles.avatarPlaceholder} />
            }
          </div>
        )}
        <h1 className={'pb-5'}>{person.name}</h1>
        <div>
          <div className={styles.birthAndDeceased}><BirthAndDeceased /></div>
          <p>{paperString}</p>
        </div>
        <InteractionStats className={styles.stats} stats={stats} />
      </div>
    </div>
  </section>
}
